import './MenuColumn.css';

interface Props {
    title: string;
    centerTitle?: boolean;
}

export function MenuColumn({ title, centerTitle, children }: React.PropsWithChildren<Props>) {
    return (
        <div className='menu-column'>
            <h4 className={`${centerTitle ? 'center' : ''}`}>{title}</h4>
            <div className='content'>{children}</div>
        </div>
    );
}
